import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  PessoaCadastroConsultaDto,
  PessoaCadastroConsultaSchema,
  PessoaCadastroProps,
  PessoaCadastroSchema,
} from "./PessoaCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  PessoaAtualizar,
  PessoaBuscarPorId,
  PessoaConsultaCadastro,
  PessoaIncluir,
} from "src/services/Entidade.Service";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
  SoNumeros,
} from "src/hook/Functions";
import { BuscarCep } from "src/services/ViaCEP";
import { showToast } from "src/componentes";
import { PessoaDto } from "../Pessoa.Dto";

const PessoaCadastroCode = (props: PessoaCadastroProps) => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const form = useForm<PessoaDto>({
    resolver: yupResolver(PessoaCadastroSchema),
    defaultValues: props.initialValue ?? {},
  });

  const consultaForm = useForm<PessoaCadastroConsultaDto>({
    resolver: yupResolver(PessoaCadastroConsultaSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await PessoaBuscarPorId(id);
          if (response.data.success) {
            const data = response.data.data;
            form.reset(data);
            setIncluir(false);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar pessoa",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          if (props.initialValue) {
            setIncluir(false);
          } else {
            setIncluir(true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const buscarCep = (cep: string) => {
    if (SoNumeros(cep).length === 8) {
      BuscarCep(cep).then((response) => {
        form.setValue("bairro", response.bairro);
        form.setValue("endereco", response.logradouro);
        form.setValue("nomeMunicipio", response.localidade);
        form.setValue("codigoMunicipio", response.ibge);
        form.setValue("uf", response.uf);
      });
    }
  };

  const onSubmitConsulta = async (data: PessoaCadastroConsultaDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    handleClose();
    data.cnpj = SoNumeros(data.cnpj);
    PessoaConsultaCadastro(data)
      .then((response) => {
        if (response.data.success) {
          const infCons = response.data.data.infCons;
          if (infCons.cStat === "111") {
            const infCad = response.data.data.infCons.infCad;
            form.setValue("nome", infCad.xNome);
            form.setValue("nomeFantasia", infCad.xNome);
            form.setValue("documento", data.cnpj);
            form.setValue("inscricaoEstadual", infCad.ie);
            form.setValue("cep", infCad.ender.cep);
            form.setValue("bairro", infCad.ender.xBairro);
            form.setValue("endereco", infCad.ender.xLgr);
            form.setValue("enderecoNumero", infCad.ender.nro);
            form.setValue("codigoMunicipio", infCad.ender.cMun);
            form.setValue("nomeMunicipio", infCad.ender.xMun);
            form.setValue("uf", data.uf);
          } else {
            showToast({
              message: infCons.xMotivo,
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          MapearErrosServidorCampo(response.data.notifications, form.setError);
          MapearErrosServidor(response.data.notifications, showToast);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSubmit = async (data: PessoaDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.cep = SoNumeros(data.cep);
    data.documento = SoNumeros(data.documento);
    if (incluir === true) {
      PessoaIncluir(data)
        .then((response) => {
          if (response.data.success) {
            if (props.onSuccess) {
              props.onSuccess(response.data.data);
              return;
            }
            navigate("/entidade/pessoa");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            showToast({
              message: "Ocorreu erro ao incluir cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = form.getValues("id");
      PessoaAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            if (props.onSuccess) {
              props.onSuccess(response.data.data);
              return;
            }
            navigate("/entidade/pessoa");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            showToast({
              message: "Ocorreu erro ao atualizar cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return {
    loading,
    onSubmit,
    form,
    buscarCep,
    show,
    handleShow,
    handleClose,
    onSubmitConsulta,
    consultaForm,
  };
};
export default PessoaCadastroCode;
